import React, { useMemo, useState, createContext } from 'react'
import { useZionAxios } from '@fs/zion-axios'

export const GroupsContext = createContext()

// Only exported for tests
export const transformResponse = (res) => {
  try {
    const response = JSON.parse(res)
    return response?.memberSummaries
      ?.map((group) => {
        group.groupId = group.id
        delete group.id
        return group
      })
      .sort((g1, g2) => g1.name.localeCompare(g2.name))
  } catch (e) {
    console.error(`useGroupsState: ${res} was returned and was not able to be parsed to JSON.`)
  }
  return undefined
}

function useGroupsState() {
  const [currentGroup, setCurrentGroup] = useState()

  const [{ data: groups }, refetchGroups] = useZionAxios({
    url: '/service/tree/tree-data/groups/current-groups?includePending=false&type=ORDINANCE_SHARING',
    transformResponse,
  })

  return useMemo(
    () => ({ groups: groups ?? [], refetchGroups, currentGroup, setCurrentGroup, noGroups: groups?.length === 0 }),
    [currentGroup, groups, refetchGroups]
  )
}

export const GroupsProvider = ({ children }) => {
  const groupsData = useGroupsState()
  return <GroupsContext.Provider value={groupsData}>{children}</GroupsContext.Provider>
}
